import Head from 'next/head';
import { TENANT_FAVICON } from '../../tenant/tenant-favicon';
import { TENANT_NAME } from '../../tenant/tenant-names';
import { HeaderProps } from '../page-wrapper';

export const Meta = (headerProps: HeaderProps) => {
  const { title, keywords, description } = headerProps;

  return (
    <Head>
      <title>{title ? `${TENANT_NAME} | ${title}` : TENANT_NAME}</title>
      <link rel="icon" href={TENANT_FAVICON} />

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords?.join(', ')} />
    </Head>
  );
};
